export class SaasMicrosoft365UserProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "userPrincipalName",
            "baseName": "userPrincipalName",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountEnabled",
            "baseName": "accountEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasMailbox",
            "baseName": "hasMailbox",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasOnedrive",
            "baseName": "hasOnedrive",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "mailboxType",
            "baseName": "mailboxType",
            "type": "string",
            "format": ""
        },
        {
            "name": "licenseStatus",
            "baseName": "licenseStatus",
            "type": "Microsoft365UserLicenseStatus",
            "format": ""
        },
        {
            "name": "licenses",
            "baseName": "licenses",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasMicrosoft365UserProperties.attributeTypeMap;
    }
    constructor() {
    }
}
